"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
/* tslint:disable */
/* eslint-disable */
__exportStar(require("./ActivityInfoApi"), exports);
__exportStar(require("./ActivityScheduleApi"), exports);
__exportStar(require("./ActivitySessionApi"), exports);
__exportStar(require("./AnnouncementsApi"), exports);
__exportStar(require("./ApLogDataApi"), exports);
__exportStar(require("./CommonApi"), exports);
__exportStar(require("./CompanyInformationApi"), exports);
__exportStar(require("./DefaultPageApi"), exports);
__exportStar(require("./FrameOrderApi"), exports);
__exportStar(require("./FrameProductApi"), exports);
__exportStar(require("./FramePromotionApi"), exports);
__exportStar(require("./InquiryOrderFormApi"), exports);
__exportStar(require("./LiffApi"), exports);
__exportStar(require("./LiffPaymentApi"), exports);
__exportStar(require("./LineFrameApi"), exports);
__exportStar(require("./LineStickerLogApi"), exports);
__exportStar(require("./LoginApi"), exports);
__exportStar(require("./MaterialColorSpecApi"), exports);
__exportStar(require("./MaterialDataApi"), exports);
__exportStar(require("./MaterialDataAttApi"), exports);
__exportStar(require("./MaterialSpecDetailApi"), exports);
__exportStar(require("./MemberOrderApi"), exports);
__exportStar(require("./MenuOptionsApi"), exports);
__exportStar(require("./NewebPayApi"), exports);
__exportStar(require("./PartnerPriceApi"), exports);
__exportStar(require("./ProductColorStyleApi"), exports);
__exportStar(require("./ProductOverviewApi"), exports);
__exportStar(require("./ProductPromotionsApi"), exports);
__exportStar(require("./ProductPromotionsDiscountApi"), exports);
__exportStar(require("./ProductPromotionsMaterialApi"), exports);
__exportStar(require("./ProductSeriesApi"), exports);
__exportStar(require("./ProductSizeApi"), exports);
__exportStar(require("./RoleApi"), exports);
__exportStar(require("./SampleApi"), exports);
__exportStar(require("./StyleDetail01Api"), exports);
__exportStar(require("./StyleDetail03Api"), exports);
__exportStar(require("./StyleManageApi"), exports);
__exportStar(require("./SysApi"), exports);
__exportStar(require("./UserApi"), exports);
__exportStar(require("./WebSiteProductMenuApi"), exports);
__exportStar(require("./WebSiteSettingApi"), exports);
